import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    gamechangersCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, { interactionDelay: 500, scrollBehaviour: 'instant' })
    }),
  }
  SAXX.Init.AddComponents(components)
})()
